import { render, staticRenderFns } from "./InputRadio.vue?vue&type=template&id=382502c4&"
import script from "./InputRadio.vue?vue&type=script&lang=js&"
export * from "./InputRadio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/production/spf-sexosafe-ezplatform/assets/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('382502c4')) {
      api.createRecord('382502c4', component.options)
    } else {
      api.reload('382502c4', component.options)
    }
    module.hot.accept("./InputRadio.vue?vue&type=template&id=382502c4&", function () {
      api.rerender('382502c4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/TestForm/components/InputRadio/InputRadio.vue"
export default component.exports